import ApplicationAdapter from '../application';

export default class Heading extends ApplicationAdapter {
  namespace = 'schools/v4';
  modelNamePlural = 'optionHeadings';

  pathForType(type) {
    type = type.replace(/^school-options\/headings?/, `schema/optionheadings`);
    return type;
  }
}
